<app-table (refreshClicked)="this.refresh()"
  (searchQueryChange)="this.refresh()"
  [(searchQuery)]="searchQuery"
  [columns]="this.columns"
  [state]="this.tableState">

  @if (this.tableState === TableStateEnum.NoData) {
    <tbody class="no-data p-4">
      <tr>
        <td [colSpan]="columns.length" class="text-center">
          <img src="/frontend/projects/app/src/assets/images/no-result-search.svg" style="width: 300px;">
          <h4 class="mt-4 mb-5 text-primary text-center h2">Aucun résultat</h4>
          <a class="btn btn-primary btn-lg" routerLink="/client-questionnaires/create"><i class="fa fa-plus"></i> Créer un
        nouveau questionnaire</a>
      </td>
    </tr>
  </tbody>
}

<tbody class="list">
  @for (result of this.getResults(); track result) {
    <tr>
      <td (click)="clientQuestionnaireClicked(result)">{{ result.clientName }}</td>
      <td (click)="clientQuestionnaireClicked(result)">{{ getKeynameText(result.keyname) }}</td>
      <td (click)="clientQuestionnaireClicked(result)">
        <span
          [class.bg-light]="result.status === 'CREATED'"
          [class.bg-success]="result.status === 'FINALIZED'"
          [class.bg-warning]="result.status === 'IN_PROGRESS'"
          class="badge rounded-pill bg-warning">{{ getStatusText(result.status) }}
        </span>
      </td>
      <td (click)="clientQuestionnaireClicked(result)">{{ getLastModifiedText(result) }}</td>
      <!--        <td> <div class="dropdown">-->
      <!--            <a href="#" class="dropdown-ellipses dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
      <!--                <i class="fas fa-ellipsis-v"></i>-->
    <!--            </a>-->
    <!--            <div class="dropdown-menu dropdown-menu-end mt-3">-->
    <!--                <a href="#" class="dropdown-item" (click)="$event.preventDefault()">-->
    <!--                    <i class="fas fa-fw fa-cloud-download me-2"></i> Exporter le calcul-->
  <!--                </a>-->
  <!--                <a href="#" class="dropdown-item" (click)="$event.preventDefault(); tryDuplicate(result.id)">-->
  <!--                    <i class="fas fa-fw fa-copy me-2"></i> Dupliquer le calcul-->
<!--                </a>-->
<!--                <hr class="dropdown-divider">-->
<!--                <a href="#" class="dropdown-item text-danger" (click)="$event.preventDefault(); tryDelete(result.id)">-->
<!--                    <i class="fas fa-fw fa-trash-alt me-2"></i> Supprimer ce calcul-->
<!--                </a>-->
<!--            </div>-->
<!--        </div></td>-->
</tr>
}
</tbody>
</app-table>

